/* eslint-disable import/prefer-default-export */

export const PARAMETER_MOTORWAY_PAGE = 'motorway_page';

export const RETAKE_RESUPPLY_PARAMETER = '&resupply=true';

export const APPROVED_WEB_APP_PAGES = Object.freeze({
  CONFIRM_DETAILS_PAGE: 'confirm-details',
});

export const isApprovedWebAppPage = (page) => Object.values(APPROVED_WEB_APP_PAGES).includes(page);
